export const isRequirementDone = (requirement, passwordValue) => {
    if (requirement.minimumCharacters && requirement.minimumCharacters <= passwordValue.length) {
        return true;
    }

    return Boolean(requirement.RegExp && requirement.RegExp.test(passwordValue));
};
